/**
 * Appends a template's content to the current message instead of replacing it.
 * An empty (or whitespace-only) message is simply replaced; otherwise the
 * template is appended after a blank line, with any trailing whitespace of the
 * current message collapsed so separators don't stack on repeated inserts.
 */
export const appendTemplateToMessage = (
	currentMessage: string,
	templateContent: string
): string => {
	if (!currentMessage.trim()) {
		return templateContent;
	}

	return `${currentMessage.replace(/\s+$/, "")}\n\n${templateContent}`;
};
